<template lang="pug">
div
  el-card(
      shadow='hover'
      v-if="!isUsuarioExterno && exibeObs"
    ).card-collapse
    app-header-dados-processo(
      :showBotaoOpcoesHeader="false"
      :processo="processo",
      :isCCR="isCCR"
      :dadosCadastros="dadosCadastros"
    )
  confirmar-dados(
    v-if="!isGerenciar",
    :dadosVtn="dadosVtn"
    :isVisualizar="isVisualizar"
    :processo="processo",
    :exibeCardObs="exibeObs"
  )
  el-card(shadow='hover' v-if="!isGerenciar && escolheuExterno && !isCriado").card-collapse
    div.cardHeader
      b Formas de pagamento:
      el-button(
        type="primary"
        @click="openModal"
        v-if="!isAVista"
      ) Tabela de amortização
    div#line
    div.centerRadio
      el-radio-group.radio-group(
          :disabled="!isUsuarioExterno || isVisualizar"
          name="Cônjuge possui certidão?",
          v-model="dadosVtn.formaPagamento"
        )
          el-radio.radio(label='PARCELADO') Pagamento parcelado
          el-radio.radio(label='A_VISTA') Pagamento à vista
    div.flexStart
      div.flex
        span Período de carência (PC):
        el-select(
          :disabled="!isUsuarioExterno || isVisualizar || isAVista"
          @change="changeCarencia && calcular(false)"
          v-model="dadosVtn.carencia"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="carencia in carencias",
            :key="carencia.id",
            :label="carencia.value",
            :value="carencia.id"
          )
      div.flex
        span Nº de parcelas anuais (n):
        el-select(
          @change="calcular(false)"
          :disabled="!isUsuarioExterno || isVisualizar || isAVista"
          v-model="dadosVtn.qntdParcelas"
          placeholder="Selecione"
          value-key="id"
        )
          el-option(
            v-for="parcela in parcelasComputed",
            :key="parcela.id",
            :label="parcela.value",
            :value="parcela.id"
          )
    div.flex.margin10(
      v-if="isEstadoAP"
    )
      el-col(:span='9').flex
        app-display(label="Resumo", content=" ", :contentAlignRight="false")
      el-col(:span='8').flex
        app-display(label="Valor(R$)", content=" ", :contentAlignRight="false")
      el-col(:span='7').flex
        app-display(label="Data vencimento", content=" ", :contentAlignRight="false")
    div.flex.margin10(v-for="parcela in dadosAmortizacaoComputed")
      el-col(:span='9').flex
        app-display.espacamento(:content="getLabel(parcela)", :contentAlignRight="false")
      el-col(:span='8').flex
        app-display.espacamento(:content="parcela.valorFormatado", :contentAlignRight="false")
      el-col(:span='7').flex
        app-display.espacamento(:content="parcela.dataVencimentoFormatada", :contentAlignRight="false")
  el-card(
    shadow='hover'
    v-if="escolheuExterno && !isCriado").card-collapse
    app-divider(label="Detalhamento da dívida: ", :addMarginTop="false").margin-top
    p(style="color: red; font-size: 13px") Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI).
    div.centerRadio
      el-col
        app-display(label="Tipo de pagamento:", :content="formaPagamentoComputed" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Quantidade de DARs emitidos:", :content="dadosVtn.qtdDarsEmitidos" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Situação da VTN:", :content="dadosDetalhamento.situacaoVtn" :contentAlignRight="true" :blackLabel="true" v-if="!isUsuarioExterno")
        app-display(label="Valor Final do Imóvel (VFI):", :content="formataMoeda(dadosVtn.valorFinalImovel)", :contentAlignRight="true" :blackLabel="true")
        app-display(label="Prazo de pagamento (PP):", :content='`${dadosDetalhamento.prazoPagamento || '-'} anos(s)`' :contentAlignRight="true" :blackLabel="true")
        app-display(label="Período de carência (PC):", :content='`${dadosVtn.carencia} ano(s)`' :contentAlignRight="true" :blackLabel="true")
        app-display(label="Nº de parcelas anuais:", :content='`${dadosVtn.qntdParcelas} parcela(s) `' :contentAlignRight="true" :blackLabel="true")
        app-display(label="Data inicial (Dti):", :content="dadosVtn.dataInicialFormatada" v-if="!isEstadoAP" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Data inicial (Dti):", :content="dadosVtn.dataCriacaoFormatada" v-if="isEstadoAP" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Data final (Dtf):", :content="dadosDetalhamento.dataFinal || '-'" :contentAlignRight="true" :blackLabel="true")
      el-col
        app-display(label="Taxa de juros anual (i):", :content="dadosVtn.taxaJurosFormatada" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Próximo vencimento:", :content="dadosVtn.qtdDarsEmitidos" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Total pago:", :content='`R$ ${dadosDetalhamento.totalPago}`' :contentAlignRight="true" :blackLabel="true" v-if="!isUsuarioExterno")
        app-display(label="Saldo devedor (DV):", :content='`${dadosDetalhamento.saldoDevedor}`', :contentAlignRight="true" :blackLabel="true" v-if="!isUsuarioExterno")
        app-display(label="Valor Final do Imóvel (VFI) após carência:", :content="dadosDetalhamento.valorFinalAposCarenciaFormatado" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Total de juros:", :content="formataMoeda(dadosDetalhamento.totalJuros)", :contentAlignRight="true" :blackLabel="true")
        app-display(label="Total de correção anual:", :content="formataMoeda(dadosDetalhamento.correcaoAnual)" :contentAlignRight="true" :blackLabel="true")
        app-display(label="Valor inicial da prestação (PMT):", :content="dadosDetalhamento.prestacaoInicial" :contentAlignRight="true" :blackLabel="true" v-if="!isUsuarioExterno")
        app-display(label="Total a pagar no final:", :content='dadosDetalhamento.totalNoFinal ? formataMoeda(dadosDetalhamento.totalNoFinal) : "-"' :contentAlignRight="true" :blackLabel="true")
  el-card(shadow='hover' v-if="isGerenciar").card-collapse
    tabela-amortizacao(:dados="dadosAmortizacao" :isVisualizar="false" :processo="processo", :disableCheck="[]")

  app-buttons-cadastro(
    v-if="isUsuarioExterno"
    :showButtonSalvar='false',
    :showButtonCancelar='!isResumo',
    :showButtonFinalizar='!isResumo',
    :isUltimoPasso='true'
    :isPrimeiroPasso='!isResumo',
    :isIntroPasso='false',
    @cancelar='cancelar',
    @finalizar='finalizar',
    @voltar='cancelar'
  )
  app-modal(
    :closeOutside="false",
    titulo="Tabela de amortização",
    :width="1000",
    @closeModal="closeModal()",
    v-if="showModal"
  )
    template(slot="body")
      tabela-amortizacao(:dados="dadosAmortizacao")
</template>

<script>
import { mapActions } from 'vuex'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import ConfirmarDados from './components/ConfirmarDados.vue'
import TabelaAmortizacao from './components/TabelaAmortizacao.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
import AppModal from '@/components/AppModal'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import parcelas from './constants/parcelas'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import { cloneDeep } from 'lodash'

export default {

  components: {
    AppHeaderDadosProcesso,
    ConfirmarDados,
    AppDivider,
    AppDisplay,
    AppModal,
    TabelaAmortizacao,
    AppButtonsCadastro
  },

  mixins: [AppNotificacao],

  props: {
    processo: {
      type: Object,
      required: true
    },
    vtn: {
      type: Object,
      required: true
    },
    isUsuarioExterno: {
      type: Boolean,
      default: false
    },
    isGerenciar: {
      type: Boolean,
      default: false
    },
    isVisualizar: {
      type: Boolean,
      default: false
    },
    exibeObs: {
      type: Boolean,
      default: false,
      required: false
    },
    escolheuExterno: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data () {
    return {
      isCCR: false,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      },
      dadosVtn: {
        carencia: 0,
        qntdParcelas: 0,
        valorFinalImovel: 0,
        formaPagamento: 'PARCELADO',
        isVtnSimulado: false,
        status: ''
      },
      carencias: [
        {
          id: 0,
          value: 'Sem carência'
        },
        {
          id: 1,
          value: '1 Ano'
        },
        {
          id: 2,
          value: '2 Anos'
        },
        {
          id: 3,
          value: '3 Anos'
        }
      ],
      isAVista: false,
      parcelas: [],
      dadosAmortizacao: [],
      showModal: false,
      dadosDetalhamento: {
        totalPago: '0,00',
        situacaoVtn: 'Em aberto',
        correcaoAnual: '0,00',
        saldoDevedor: '',
        saldoAposCarencia: '',
        prestacaoInicial: '',
        totalJuros: ''
      },
      carenciaSelect: 1
    }
  },

  computed: {
    parcelasComputed () {
      return this.parcelas.slice(0, this.parcelas.length - (this.carenciaSelect || 0))
    },
    formaPagamentoComputed () {
      return this.dadosVtn.formaPagamento === 'PARCELADO' ? 'Parcelado' : 'À vista'
    },
    isResumo () {
      return this.isUsuarioExterno && this.isVisualizar
    },
    isCalculando () {
      return this.dadosVtn.status === 'Criado' && !this.dadosVtn.formaPagamento
    },
    isCriado () {
      return this.dadosVtn.status === 'Criado' && !this.isUsuarioExterno
    },
    dadosAmortizacaoComputed () {
      return this.dadosAmortizacao
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    }
  },

  watch: {
    'dadosVtn.formaPagamento': {
      async handler (oldVal, newVal) {
        if (oldVal === 'A_VISTA') {
          this.dadosVtn.qntdParcelas = 1
          this.dadosVtn.carencia = 0
          this.calcular()
          this.dadosDetalhamento.totalJuros = 0
          this.isAVista = true
        } else {
          this.calcular()
          this.isAVista = false
        }
      }}
  },

  async created () {
    await this.reseteParcelas(this.vtn.id)
    this.dadosVtn = await this.findVtnById(this.vtn.id)
    this.dadosVtn = {
      ...this.dadosVtn,
      isVtnSimulado: false,
      formaPagamento: this.getFormaPagamento(),
      carencia: this.dadosVtn.carencia === null ? 0 : this.dadosVtn.carencia,
      qntdParcelas: this.isEstadoAP ? this.dadosVtn.parcelasAp?.length : this.dadosVtn.qntdParcelas === null ? 1 : this.dadosVtn.qntdParcelas
    }
    if (this.dadosVtn.status.toUpperCase() !== 'CRIADO' && this.isEstadoAP) {
      this.isVisualizar = true
    }
    if (!this.isUsuarioExterno) {
      this.dadosDetalhamento = {
        ...this.dadosDetalhamento,
        saldoDevedor: this.dadosVtn.parcelasAp[0].saldoDevedorFormatado,
        saldoAposCarencia: this.dadosVtn.parcelasAp[0].saldoDevedorFormatado,
        prestacaoInicial: this.dadosVtn.parcelasAp[0].valorFormatado,
        totalJuros: this.dadosVtn.parcelasAp.map(dado => { return dado.juros }).reduce((previousValue, currentValue) => previousValue + currentValue, 0),
        dataFinal: this.dadosVtn.parcelasAp.at(-1).dataVencimentoFormatada,
        prazoPagamento: this.dadosVtn.qntdParcelas + this.dadosVtn.carencia,
        totalNoFinal: this.dadosVtn.parcelasAp.map(dado => { return dado.valor }).reduce((total, valor) => total + valor, 0) - this.dadosVtn.parcelasAp[0].valor
      }
    }
    this.parcelas = cloneDeep(parcelas.parcelas)
    this.dadosAmortizacao = this.dadosVtn.parcelasAp
    if (this.isEstadoAP) {
      this.dadosVtn.qntdParcelas = this.dadosVtn.parcelasAp?.length ? this.dadosVtn.parcelasAp.length : 1
    }
    this.dadosAmortizacao.sort((p1, p2) => {
      if (p1.numero < p2.numero) {
        return -1
      } else {
        return 1
      }
    })

    await this.calcular()
  },

  methods: {
    ...mapActions({
      findVtnById: 'vtn/findVtnById',
      calcularVtn: 'vtn/calcularVtn',
      updateVtn: 'vtn/updateVtn',
      tramitarComAcao: 'processo/tramitarComAcao',
      reseteParcelas: 'vtn/reseteParcelas'
    }),

    changeCarencia () {
      this.carenciaSelect = this.dadosVtn.carencia
    },

    async calcular (isFinalizar = false) {
      this.dadosVtn.vtn = {
        ...this.dadosVtn,
        vtn: this.vtn
      }
      const formaPagamento = !this.dadosVtn.formaPagamento
        ? this.getFormaPagamento()
        : this.dadosVtn.formaPagamento
      const dadosVtn = {
        ...this.dadosVtn,
        coeficientAngular: null,
        coeficienteLinear: null,
        formaPagamento: formaPagamento,
        vtn: {
          ...this.dadosVtn.vtn,
          coeficientAngular: null,
          coeficienteLinear: null,
          formaPagamento: formaPagamento
        },
        isFinalizar: isFinalizar
      }
      let dados = await this.calcularVtn(dadosVtn)
      this.dadosDetalhamento = {
        ...this.dadosDetalhamento,
        saldoDevedorUpdate: dados[0].saldoDevedor,
        saldoDevedor: dados[0].saldoDevedorFormatado,
        saldoAposCarencia: dados[0].saldoDevedorFormatado,
        prestacaoInicial: dados[1].valorFormatado,
        totalJuros: dados.map(dado => { return dado.juros }).reduce((previousValue, currentValue) => previousValue + currentValue, 0),
        dataFinal: this.isCalculando ? '-' : dados.at(-1).dataVencimentoFormatada,
        prazoPagamento: this.dadosVtn.qntdParcelas + this.dadosVtn.carencia,
        totalNoFinal: dados.map(dado => { return dado.valor }).reduce((total, valor) => total + valor, 0) - dados[0].valor
      }
      if (isFinalizar) {
        this.dadosVtn = {
          ...this.dadosVtn,
          status: 'AGUARDANDO_VALIDACAO'
        }
      }

      const data = await this.atualizarVtn(dados)

      this.dadosDetalhamento = {
        ...this.dadosDetalhamento,
        valorFinalAposCarenciaFormatado: data.valorFinalAposCarenciaFormatado
      }

      this.dadosAmortizacao = dados.splice(1, dados.length)
    },

    closeModal () {
      this.showModal = false
    },

    openModal () {
      this.showModal = true
    },

    cancelar () {
      this.$router.back()
    },

    goToListagem () {
      this.$router.back()
    },

    async atualizarVtn (dados) {
      const dadosUpdate = {
        ...this.dadosVtn,
        percentualCalculado: this.dadosVtn.percentualAplicado * 100,
        idProcesso: this.processo.id,
        saldoDevedor: dados[0].saldoDevedor,
        qntdParcelas: this.dadosVtn.qntdParcelas,
        carencia: this.dadosVtn.carencia,
        valorEntrada: 0,
        dataInicial: dados[1].dataVencimento,
        totalJuros: dados.map(dado => { return dado.juros }).reduce((previousValue, currentValue) => previousValue + currentValue, 0).toFixed(2),
        totalPago: 0,
        formaPagamento: this.isEstadoAP ? this.dadosVtn.formaPagamento : this.getFormaPagamento(),
        municipio: this.processo.municipios[0] || 1600105,
        qtdModuloFiscal: this.dadosVtn.nModuloFiscal,
        moduloFiscal: this.dadosVtn.pvtn.municipio.mf,
        valorFinalAposCarencia: dados[0].valor,
        status: this.dadosVtn.status
      }

      return this.updateVtn(dadosUpdate)
    },

    getLabel (value) {
      return value?.numero === 0 ? 'Valor do VTN' : `Parcela ${value.numero}`
    },

    async finalizar () {
      await this.calcular(true)
      const municipio = this.processo.municipios[0] || this.processo.dadosCadastro.dados.cadastro.imovel.municipio
      this.dadosVtn.parcelasAp = this.dadosAmortizacao
      this.dadosVtn.municipio = municipio
      this.dadosVtn.qtdModuloFiscal = this.dadosVtn.nModuloFiscal
      this.dadosVtn.moduloFiscal = this.dadosVtn.pvtn.municipio.mf

      await this.tramitarComAcao({
        processoId: this.processo.id,
        acao: 'AGUARDANDO_VALIDACAO.COORDENADOR.CRF'
      })
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.mensagemEscolhaPagamento()
      )
      this.goToListagem()
    },

    mensagemEscolhaPagamento () {
      return 'Forma de pagamento escolhida com sucesso!'
    },

    voltar () {
      this.$router.push({
        name: 'GESTAO_VTN'
      })
    },

    getFormaPagamento () {
      return this.dadosVtn.formaPagamento === null || this.dadosVtn.formaPagamento === 'null' ? 'PARCELADO' : this.dadosVtn.formaPagamento.codigo
    },

    formataMoeda (valor) {
      let formatado = valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      return formatado
    }
  }
}
</script>

<style lang="scss" scoped>
.card-collapse {
  border-radius: 10px;
  margin: 20px;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.centerRadio {
  display: flex;
  justify-content: center;
  margin-top: 5%;
  gap: 3%;
}

.margin-top {
  margin-top: 5%;
}

.flexStart {
  display: flex;
  margin-top: 5%;
  justify-content: flex-start;

  .flex {
    flex: 1;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
  }
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.buttons {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 20px 10px;
}

.margin10 {
  margin: 20px 10px 5px 10px;
}

.espacamento {
  margin-left: -7px !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/VisualizarVtn.vue